import React from "react";
import PropTypes from "prop-types";

import classNames from "classnames";
import getDisplayName from "utils/getDisplayName";

import Tooltip from "components/library/Tooltip";
import styles from "./Tooltip.css";

export default function withTooltip(WrappedComponent) {
  class WithTooltip extends React.Component {
    constructor(props) {
      super(props);
      this.state = { isTooltipOpen: false, tooltipText: props.tooltip };

      this.handleTooltipOpen = this._handleTooltipOpen.bind(this);
      this.handleTooltipClose = this._handleTooltipClose.bind(this);
      this.setTooltipText = this._setTooltipText.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.tooltip !== nextProps.tooltip) {
        this.setState({ tooltipText: nextProps.tooltip });
      }
    }

    _handleTooltipOpen() {
      this.setState({ isTooltipOpen: true });
    }

    _handleTooltipClose() {
      this.setState({ isTooltipOpen: false });
    }

    _setTooltipText(text) {
      this.setState({ tooltipText: text });
    }

    render() {
      return (
        <div
          className={classNames(styles.wrapper, {
            [styles.hasTooltip]: this.state.tooltipText,
          })}
          onMouseLeave={this.handleTooltipClose}
          onMouseEnter={this.handleTooltipOpen}
        >
          <WrappedComponent
            {...this.props}
            setTooltipText={this.setTooltipText}
            componentref={this.props.componentref}
          />
          <Tooltip
            isOpen={this.state.isTooltipOpen}
            text={this.state.tooltipText}
            isLeftAligned={this.props.isTooltipLeftAligned}
          />
        </div>
      );
    }
  }

  WithTooltip.displayName = `WithTooltip(${getDisplayName(WrappedComponent)})`;
  WithTooltip.WrappedComponent = WrappedComponent;

  return WithTooltip;
}

withTooltip.propTypes = {
  isTooltipLeftAligned: PropTypes.bool,
  componentref: PropTypes.func,
};
